<template>
  <div>
    <table class="table table-hover table-bordered table-sm mt-1">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th scope="col">Número</th>
          <th scope="col">Ocupación</th>
          <th scope="col">Asignar</th>
          <th scope="col">Info</th>
          <th scope="col">PDF</th>
          <th scope="col">Acciones</th>
        </tr>
      </thead>
      <tbody v-if="pendingBuses.length == 0">
        <tr>
          <td colspan="7">Por ahora no hay buses creados disponibles</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr
          v-for="(bus, index) in pendingBuses"
          :key="index"
          class="busCard"
          :id="bus.id"
          :style="selected == bus.id ? selectedBus : unSelectedBus"
        >
          <td>
            <bus-name-badge :bus="bus" />
            <br/>
            <i class="fa fa-fw" :class="bus.used_excursion ? 'fa-check-circle text-success' : 'fa-times-circle text-warning'" :title="bus.used_excursion ? 'Bus usado para excursión' : 'Bus NO usado para excursión'"></i>
            <i class="fa fa-fw" :class="bus.used_pickup ? 'fa-check-circle text-success' : 'fa-times-circle text-warning'" :title="bus.used_pickup ? 'Bus usado para recogidas' : 'Bus NO usado para recogidas'"></i>
            <i class="fa fa-fw" :class="bus.used_return ? 'fa-check-circle text-success' : 'fa-times-circle text-warning'" :title="bus.used_return ? 'Bus usado para dejadas' : 'Bus NO usado para dejadas'"></i>
          </td>
          <td>{{ bus.number }}</td>
          <td>
            <div class="text-center">
              <bus-occupancy-badge :maxSize="bus.max_size" :adults="bus.count_adults" :children="bus.count_children" />
            </div>
          </td>
          <td class="text-center">
            <b-form-checkbox
              switch
              size="lg"
              @change="onCbxAssignClickHandler(bus.id)"
              :id="bus.id + '-check'"
              :checked="isChecked(bus.id)"
              :disabled="isDisabled(bus)"
            ></b-form-checkbox>
            
          </td>

          <td class="text-center d-flex align-items-baseline">
            <!-- <EditBusInfoModal
              :disabledButton="disabledButton"
              :busId="bus.id"
            ></EditBusInfoModal> -->
            <b-button
              class="border"
              size="sm"
              variant="light"
              v-b-modal="'editBusInfo_' + bus.id"
            >
              <i class="text-center fa fa-info"></i>
            </b-button>
            <i class="fa fa-user ml-1" :style="guideProcessingStyle(bus.bustype_set)" :title="guideProcessingName(bus.bustype_set)"></i>
            <i class="fa fa-car ml-1" :style="busCompanyProcessingStyle(bus)" :title="busCompanyProcessingName(bus)"></i>
            <edit-bus-info-modal :busId="bus.id" />
          </td>
          <td class="text-center">
            <b-button
              size="sm"
              class="border"
              variant="light"
              @click="pdfGenerate(bus.id, bus.name, index)"
              
            >
              <i
                v-if="indexSelected !== index"
                class="text-center fa fa-book"
              ></i>
              <b-spinner
                v-if="loading && indexSelected === index"
                small
              ></b-spinner>
            </b-button>
          </td>
          <td class="text-center">
            <div>
              <b-dropdown
                size="lg"
                variant="link"
                right
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item>
                  <div v-b-modal="'editBus_' + bus.id">
                    <i class="fa fa-edit mr-2 fa-fw"/> Editar
                  </div>
                  <edit-bus-modal :busId="bus.id" />
                </b-dropdown-item>
                <b-dropdown-item>
                  <DeleteBusModal
                    :listBuses="buses"
                    :disabledButton="disabledButton"
                    :busId="bus.id"
                  ></DeleteBusModal>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="path == 'Excursion'"
                  @click="closingTest(bus.id)"
                >                 
                    <i
                      :disabled="disabledButton"
                      class="fa fa-check-circle mr-2"
                    ></i> Cerrar
                  <warn-close-bus-modal :bus="bus" />
                </b-dropdown-item>
                <b-dropdown-item>
                  <div v-b-modal="'emptyBus_' + bus.id">
                    <i class="fa fa-trash-o mr-2 fa-fw"/> Vaciar
                  </div>
                  <empty-bus-modal :bus="bus" />
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      
    </table>
    <span class>Buses cerrados</span>
    <table class="table table-hover table-bordered table-sm mt-1">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th scope="col">Número</th>
          <th scope="col">Ocupación</th>
          <th scope="col">Info</th>
          <th scope="col">PDF</th>
          <th scope="col">Acciones</th>
        </tr>
      </thead>
      <tbody v-if="closedBuses.length == 0">
        <tr>
          <td colspan="6">Por ahora no hay ningún bus cerrado</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr
          v-for="(bus, index) in closedBuses"
          class="busCard"
          :style="selected == bus.id ? selectedBus : unSelectedBus"
          :key="index"
          :id="bus.id"
        >
          <td>
            <bus-name-badge :bus="bus"/>
            <br/>
            <i class="fa fa-fw" :class="bus.used_excursion ? 'fa-check-circle text-success' : 'fa-times-circle text-warning'" :title="bus.used_excursion ? 'Bus usado para excursión' : 'Bus NO usado para excursión'"></i>
            <i class="fa fa-fw" :class="bus.used_pickup ? 'fa-check-circle text-success' : 'fa-times-circle text-warning'" :title="bus.used_pickup ? 'Bus usado para recogidas' : 'Bus NO usado para recogidas'"></i>
            <i class="fa fa-fw" :class="bus.used_return ? 'fa-check-circle text-success' : 'fa-times-circle text-warning'" :title="bus.used_return ? 'Bus usado para dejadas' : 'Bus NO usado para dejadas'"></i>
          </td>
          <td>{{ bus.number }}</td>
          <td>
            <div class="text-center">
              <bus-occupancy-badge :maxSize="bus.max_size" :adults="bus.count_adults" :children="bus.count_children" />
            </div>
          </td>
          <td class="text-center">
            <b-button
              class="border"
              size="sm"
              variant="light"
              v-b-modal="'editBusInfo_' + bus.id"
            >
              <i class="text-center fa fa-info"></i>
            </b-button>
            <EditBusInfoModal
              :disabledButton="disabledButton"
              :busId="bus.id"
            ></EditBusInfoModal>
            <i class="fa fa-user ml-1" :style="guideProcessingStyle(bus.bustype_set)" :title="guideProcessingName(bus.bustype_set)"></i>
            <i class="fa fa-car ml-1" :style="busCompanyProcessingStyle(bus)" :title="busCompanyProcessingName(bus)"></i>
          </td>
          <td class="text-center">
            <b-button
              size="sm"
              class="border"
              variant="light"
              @click="pdfGenerate(bus.id, bus.name, index)"
              
            >
              <i
                v-if="indexSelected !== index"
                class="text-center fa fa-book"
              ></i>
              <b-spinner
                v-if="loading && indexSelected === index"
                small
              ></b-spinner>
            </b-button>
          </td>
          <td class="text-center">
            <div>
              <b-dropdown
                size="lg"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <i v-if="activeTab == 'Excursions'" class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item>
                  <open-bus-btn v-if="activeTab == 'Excursions'" :busId="bus.id" />
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="5">
            Generar PDFs
            <b-button @click="generateAllPdf()" :variant="'light'" class="mx-1 border">
              <span v-if="!generatingAllPdfLoading">Disparar</span>
              <span v-else><i class="fa fa-spinner fa-spin mr-2"></i></span>
            </b-button>
          </td>
        </tr>

         <tr v-if="path == 'Excursion'">
          <td colspan="5">
            Sincronizar con manifiestos 
            <b-button @click="triggerAssignGuideManifest()" :variant="'light'" class="mx-1 border">
              <span v-if="!updatingAssignGuideManifest">Disparar</span>
              <span v-else><i class="fa fa-spinner fa-spin mr-2"></i></span>
            </b-button>
            <p v-if="asignGuideResponse.status == 'ok'" class="alert alert-success font-weight-bold">
              {{asignGuideResponse.message}}
            </p>
             <p v-if="asignGuideResponse.status == 'ko'" class="alert alert-danger font-weight-bold">
              {{asignGuideResponse.message}}
            </p>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import axios from "axios";


import utilsColors from "../../../../utils/colors";
import EditBusModal from "../BusModal/EditBusModal";
import DeleteBusModal from "../BusModal/DeleteBusModal";
import EditBusInfoModal from "../BusModal/EditBusInfoModal";
import EmptyBusModal from "../BusModal/EmptyBusModal"
import { EventBus } from "../../../../EventBus";
import OpenBusBtn from "../../Bus/OpenBusBtn";
import BusOccupancyBadge from "../BusUtils/BusOccupancyBadge"
import BusNameBadge from '../BusUtils/BusNameBadge'
import WarnCloseBusModal from '../BusModal/WarnCloseBusModal'

export default {
  components: {
    EditBusModal,
    DeleteBusModal,
    EditBusInfoModal,
    OpenBusBtn,
    EmptyBusModal,
    WarnCloseBusModal,
    BusOccupancyBadge,
    BusNameBadge
  },
  props: [
    "buses", "loading", "indexSelected", "pdfGenerate", "busesType"
  ],
  data() {
    return {
      disabledButton: false,
      selected: "",
      selectedBusId: "",
      selectedBus: {
        backgroundColor: "#FFFCBA",
        color: "#0465CD",
      },
      unSelectedBus: {
        backgroundColor: "",
        color: "",
      },
      generatingAllPdfLoading: false,
      updatingAssignGuideManifest: false,
      asignGuideResponse: {
        'status': '',
        'message': ''
      }
    };
  },
  async mounted() {
    this.$store.dispatch("buscompanies/retrieveBusCompanies")

  },
  mixins: [utilsColors],
  methods: {
    onCbxAssignClickHandler(busId) {
      let checkbox = document.getElementById(busId + "-check");
      let options = {
        isChecked: {
          busId: busId,
          disabledButton: true,
          disabled: true,
        },
        notChecked: {
          busId: "",
          disabledButton: false,
          disabled: false,
        },
      };
      let currentOption = checkbox.checked ? "isChecked" : "notChecked";

      this.selected = options[currentOption].busId;
      this.disabledButton = options[currentOption].disabledButton;
      this.selectedBusId = options[currentOption].busId;
      EventBus.busIdChange(this.selectedBusId); // This is for pass busId to grandfather
    },
    isChecked(busId) {
      return this.selectedBusId == busId ? true : false;
    },
    isDisabled(bus) {
      return ( 
        this.selected !== '' && this.selected !== bus.id ) 
        || ( this.activeTab === 'Excursions' && this.activeOption === 'Excursion' )
          || ( this.activeTab === 'Pickups' && this.activeOption === 'Excursion' )
            || ( this.activeTab === 'Pickups' && this.activeOption === 'Pickup'
              || ( this.activeTab == 'Excursions' && this.activeOption == 'NoService')
                || ( this.activeOption == 'Pickups' && this.activeOption == 'NoService') )
    },
    async closeBus(id) {
      const busData = {
        date: this.$store.getters.filterDate,
        group: this.$store.getters.filterGroup,
        bus_type: this.path,
      };

      try {
        await this.$store.dispatch("bookingsBus/closeBus", id);
      } catch (ex) {
        this.error = "Failed to load data";
      } finally {

        this.$notify({
          group: "foo",
          title: "Bus cerrado",
          text: "Se ha cerrado el bus seleccionado",
          type: "info",
        });
      }
    },
    async closingTest(id) {
      try {
        const data = await this.$store.dispatch("bookingsBus/closingTest", id)
        if ( data.result == 0 ) {
          // proceed with closing silently
          await this.closeBus(id)
        } else {
          // show warning modal
          this.$bvModal.show('closeBus_' + id)
        }
      }  catch (e) {

      }
    },
    showEditBusInfoModal() {
      this.$bvModal.show('editBusInfo_' + this.busId);
    },
    guideProcessingStyle(bustype_set) {
      let filtered = bustype_set.find((item) => item.bus_type.toLowerCase() == this.busesType)
      if ( filtered != null && filtered.person_name != "" ) {
        return 'color: green; font-weight: 600;'
      } else {
        return 'color: red; font-weight: 600;'
      }
    },
    guideProcessingName(bustype_set) {
      let guideName = bustype_set.find((item) => item.bus_type.toLowerCase() == this.busesType)
      if ( guideName != null && guideName.person_name != "" ) 
        return "Guía asignado: " + guideName.person_name
      return "Guía sin asignar"
    },
    busCompanyProcessingStyle(bus) {
      if ( bus != null && bus.bus_company != null ) {
        return 'color: green; font-weight: 600;'
      } else {
        return 'color: red; font-weight: 600;'
      }
    },
    busCompanyProcessingName(bus) {
      if ( bus != null && bus.bus_company != null ) {
        let company = this.busCompanies.find((item) => item.id == bus.bus_company)
        let companyName = company != null && company.name != null ? company.name : '?'
        return "Compañía asignada: " + companyName
      }
      return "Compañía sin asignar"
    },
    async generateAllPdf() {
      const buses = this.pendingBuses.concat(this.closedBuses)
      this.generatingAllPdfLoading = true
      let tasks = []
      for (let index in buses) {
        tasks.push( this.pdfGenerate(buses[index].id, buses[index].name, index) )
        //await Promise.allSettled([this.pdfGenerate(buses[index].id, buses[index].name, index)])
      }
      await Promise.allSettled(tasks)
      this.generatingAllPdfLoading = false
    },

    async triggerAssignGuideManifest() {
      this.updatingAssignGuideManifest = true

      const baseUrl = process.env.VUE_APP_BASE_API + "/excursion";
      
      await axios({
        url:
          baseUrl +
          `/manifests-guides/sync_guides/?day=${this.filterDate}&activity_group_id=${this.currentGroup.id}&bus_type=${this.path}`,
        method: "GET",
      }).then((response) => {
        this.updatingAssignGuideManifest = false
        this.asignGuideResponse = {
          status: "ok",
          message: "Proceso de sincronización terminado satisfactoriamente"
        }
        setTimeout(() => {
          this.asignGuideResponse.status = ''
        }, 5000);
      }).catch((error  => {
        this.updatingAssignGuideManifest = false
        this.asignGuideResponse = {
          status: "ko",
          message: 'Error (' + error.response.status + '): ' + ( error.response.data != null ? error.response.data.error : error.response)
        }
        // TODO: show exit
        setTimeout(() => {
          this.asignGuideResponse.status = ''
          
        }, 5000);
      } ));
      
    }
  },
  computed: {
    ...mapGetters(["activeTab", "activeOption", "busCompanies", "filterDate", "currentSuprazone", "currentGroup"]),
    path() {
      //return this.$route.path == "/app/excursiones/excursiones" ? "Excursion" : "Pickup";
      if ( this.$route.path == "/app/excursiones/excursiones")
        return "Excursion"
      else if ( this.$route.path == "/app/excursiones/pickups")
        return "Pickup"
      else if ( this.$route.path == "/app/excursiones/returns")
        return "Return"
    },
    filterBusToViewInEachScreen() {
      if ( this.path == "Excursion" )
        return this.buses.filter( (item) => item.used_excursion )
      else if ( this.path == "Pickup" )
        return this.buses.filter( (item) => item.used_pickup )
      else if ( this.path == "Return")
        return this.buses.filter( (item) => item.used_return )
    },
    pendingBuses() {
      return this.filterBusToViewInEachScreen.filter((b) => !b.bus_closed);
    },
    closedBuses() {
      return this.buses.filter((b) => b.bus_closed);
    },
    
  },
};
</script>

<style>
.dropdown-toggle::after {
  display: none !important;
}

.fa-ellipsis-v:before {
  color: #29323a !important;
}
</style>